module.exports = __webpack_public_path__ + "static/kvm_10.704ed422.jpg";